import { PlpSeoActionsUnion, PlpSeoActionTypes } from './plp-seo.actions';
import { PlpSeoInitialState } from './plp-seo.state';

export function plpSeoReducer(
  state = PlpSeoInitialState,
  action: PlpSeoActionsUnion
) {
  switch (action.type) {
    case PlpSeoActionTypes.LOAD_PLP_SEO_CONTENT:
      return {
        ...state,
        loading: true
      };
    case PlpSeoActionTypes.LOAD_PLP_SEO_CONTENT_SUCCESS:

      return {
        ...state,
        plpSEOContent: action.payload.plpSEOContent
      };
    case PlpSeoActionTypes.LOAD_PLP_SEO_CONTENT_FAILURE:
      return {
        ...PlpSeoInitialState,
        error: action.payload.error
      };
    default:
      return state;
  }
}
